import { useParams } from 'react-router-dom'
import SellOrderCreateStep from './Steps/SellOrderCreateStep'
import SellOrderFinishedStep from './Steps/SellOrderFinishedStep'
import SellOrderWaitingResponseStep from './Steps/SellOrderWaitingResponseStep'
import { sellOrderStatusInversed } from '@teinor/erp/types/company/order/sell/sellOrder'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { TableComponentProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import useOrderScreenLogic from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useOrderScreenLogic'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import SellOrderCreateNoPermissionStep from './Steps/SellOrderCreateNoPermissionStep'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { WorkSheetGroupStatusesPayload } from '../../../../../../../../utils/reducers/sells/workSheetGroupStatus'


interface SingleSellOrderProps extends TableComponentProps { }

const SingleSellOrder: React.FC<SingleSellOrderProps> = ({ userPermissions }) => {
    const params = useParams<{ id: string }>()
    const OrderId = params.id
    
    const inputTableURLs: InputTableURLsTable = {
        createData: ['/api/app/order/sell/sellOrder/orderProduct/createSellOrderProduct', { OrderId }],
        getData: ['/api/app/order/sell/sellOrder/getSellOrderComplete', { id: OrderId }],
        updateData: '/api/app/order/sell/sellOrder/orderProduct/updateSellOrderProduct',
        delete: '/api/app/order/sell/sellOrder/orderProduct/deleteSellOrderProduct',
        updateHeaderData: '/api/app/order/sell/sellOrder/updateSellOrder',
        getSubProducts: ['/api/app/order/sell/sellOrder/orderProduct/getAllSubSellOrderProducts', ['CustomerId']],
        updateOrderLines: '/api/app/order/sell/sellOrder/updateSellOrderNLines',
        printTags: '/api/app/order/sell/sellOrder/printSellOrderTags'
    }
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, headerChanges } = useOrderScreenLogic({ inputTableURLs, userPermissions: 'sell.order'})
    const status = parseInt(completeData?.header.status)
     if (!permissionCheck(getUserPermissions('sell.order'), 'update') || completeData?.header.hidePrices || completeData?.header.notModificable) {
        return <SellOrderCreateNoPermissionStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    } else if (status === sellOrderStatusInversed['waitingResponse'] || status === sellOrderStatusInversed['pendingUnits']) {
        return <SellOrderWaitingResponseStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    } else if (status === sellOrderStatusInversed['denied'] || status === sellOrderStatusInversed['accepted']) {
        return <SellOrderFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    }
    return <SellOrderCreateStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
}

const workSheetGroupStatusesDispatch = {
    setWorkSheetGroupStatuses: (payload: WorkSheetGroupStatusesPayload) => ({ type: 'CHANGE_WORKSHEETGROUPSTATUSES', payload }),
}

export type ReduxWorkSheetGroupStatus = ConnectedProps<typeof workSheetGroupStatusConnect>
const mapWorkSheetGroupStatusConnector = (state: AllReduxPayloads) => ({ workSheetGroupStatuses: state.workSheetGroupStatuses })
const workSheetGroupStatusConnect = connect(mapWorkSheetGroupStatusConnector, workSheetGroupStatusesDispatch)
const workSheetGroupStatusConnectLoading = withLoading(SingleSellOrder, [{ fetchUrl: '/api/app/order/sell/workSheet/workSheetGroupStatus/getAllWorkSheetGroupStatusesComplete', propName: 'workSheetGroupStatuses', setFunctionName: 'setWorkSheetGroupStatuses' }])
const SingleSellOrderConnect = workSheetGroupStatusConnect(workSheetGroupStatusConnectLoading)

export default SingleSellOrderConnect
